import type { components } from '../api/schema.gen.ts';
import type { Item } from '../features/items/itemsApi.ts';

/**
 * Hub event shapes, taken from the generated OpenAPI types.
 *
 * SignalR contracts are not part of an OpenAPI document, so the API exposes a
 * `/api/contracts/hub-events` endpoint whose only job is to drag every event DTO into
 * the schema. These aliases point at those generated types, so a change to a server DTO
 * shows up here as a type error rather than as a runtime surprise. Nothing in this file
 * redefines a shape by hand.
 */
type Schemas = components['schemas'];

export type ActorInfo = Schemas['ActorInfo'];
export type ItemAddedEvent = Schemas['ItemAddedEvent'];
export type ItemCheckedEvent = Schemas['ItemCheckedEvent'];
export type ItemUncheckedEvent = Schemas['ItemUncheckedEvent'];
export type ItemUpdatedEvent = Schemas['ItemUpdatedEvent'];
export type ItemDeletedEvent = Schemas['ItemDeletedEvent'];
export type ListClearedEvent = Schemas['ListClearedEvent'];
export type SuggestionsChangedEvent = Schemas['SuggestionsChangedEvent'];
export type ItemImagesChangedEvent = Schemas['ItemImagesChangedEvent'];
export type AislesChangedEvent = Schemas['AislesChangedEvent'];
export type MemberJoinedEvent = Schemas['MemberJoinedEvent'];
export type MemberLeftEvent = Schemas['MemberLeftEvent'];
export type PresenceChangedEvent = Schemas['PresenceChangedEvent'];

/** Must match `HubEvents` on the server. */
export const HubEvent = {
  ItemAdded: 'ItemAdded',
  ItemChecked: 'ItemChecked',
  ItemUnchecked: 'ItemUnchecked',
  ItemUpdated: 'ItemUpdated',
  ItemDeleted: 'ItemDeleted',
  ListCleared: 'ListCleared',
  SuggestionsChanged: 'SuggestionsChanged',
  ItemImagesChanged: 'ItemImagesChanged',
  AislesChanged: 'AislesChanged',
  MemberJoined: 'MemberJoined',
  MemberLeft: 'MemberLeft',
  PresenceChanged: 'PresenceChanged',
} as const;

export interface JoinListResult {
  success: boolean;
  present: ActorInfo[];
}

/** How the app describes its connection to the user. */
export type ConnectionState = 'offline' | 'connecting' | 'live' | 'syncing';

/**
 * The item shape carried by hub events matches the REST one. Asserted structurally
 * here so a divergence is a compile error rather than a subtly wrong render.
 */
export type HubItem = Item;
